import React from 'react';
import PropTypes from 'prop-types';
import CardVideo from './CardVideo';

const SpecialOpsVideoSlide = ({
  sessionId,
  setVideoRef,
  specialOpsVideoUrl,
  onPlay,
  isVideoBeingProcessed,
}) => (
  <CardVideo
    sessionId={sessionId}
    setVideoRef={setVideoRef}
    videoUrlPath={specialOpsVideoUrl}
    onPlay={onPlay}
    isVideoBeingProcessed={isVideoBeingProcessed}
  />
);

SpecialOpsVideoSlide.propTypes = {
  sessionId: PropTypes.string.isRequired,
  setVideoRef: PropTypes.func,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  onPlay: PropTypes.func,
  isVideoBeingProcessed: PropTypes.bool.isRequired,
};

SpecialOpsVideoSlide.defaultProps = {
  setVideoRef: () => { },
  onPlay: undefined,
};

export default SpecialOpsVideoSlide;
